import { ReloadOptions } from "@kontur.candy/candy-widget-npm-loader";

import { CandyThunkAction } from "../../../../Engine/Core/Store/CandyReduxTypes";
import { loadInitialAttachments } from "../../../../Engine/Externals/Attachments/Store/AttachmentsActions";
import { loadAttachments } from "../../../../Forms/FormInitialization/DataFetching";

export function reloadAfterHistoryEditingAction(options: ReloadOptions): CandyThunkAction {
    return async (dispatch, _, form) => {
        await form.reloadInner();

        if (
            options.undoResponse.changedAttachments != undefined &&
            options.undoResponse.changedAttachments.length > 0
        ) {
            const actualAttachments = await loadAttachments(form.candyApiDraftClient);
            dispatch(loadInitialAttachments(actualAttachments));
        }
    };
}
